/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementIncidentManagementConfigurationMapping extends models.JiraServiceManagementConfigurationMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementIncidentManagementConfigurationMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementIncidentManagementConfigurationMapping>): JiraServiceManagementIncidentManagementConfigurationMapping {
        let obj = Object.assign(new JiraServiceManagementIncidentManagementConfigurationMapping(), model);
        JiraServiceManagementIncidentManagementConfigurationMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementIncidentManagementConfigurationMapping>): JiraServiceManagementIncidentManagementConfigurationMapping {
        if (!model) return null;
        return JiraServiceManagementIncidentManagementConfigurationMapping.newInstance(<JiraServiceManagementIncidentManagementConfigurationMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMapping) {
        if (!obj) return;

        models.JiraServiceManagementIncidentManagementConfigurationMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMapping): boolean {
        if (models.JiraServiceManagementConfigurationMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementIncidentManagementConfigurationMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
